import { createPortal } from "react-dom";
import { ModalCarousel, ModalSwiper } from "./styles";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { SwiperSlide } from "swiper/react";
import Image from "next/image";
import { getImage, getImageProp, ImageProps, SimpleLinkProps, VideoProps, FULL_WIDTH } from "@itchannelplus/utils";
import {
  NextButton,
  PreviousButton,
} from "../buttons/ControlButtons";
import React, { ReactNode } from "react";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import type { AutoplayOptions } from "swiper/types";
import Video from "../Video";
//import { VariantProps } from "@phntms/css-components";

export interface CarouselModalProps {
  slides: {
    image?: string | StaticImport | ImageProps;
    video?: string | VideoProps;
    caption?: string | ReactNode;
    title?: string;
    link?: SimpleLinkProps;
  }[];
  autoplay?: AutoplayOptions | boolean;
  onClose?: () => void;
  isOpened?: boolean;
  [key: string]: any;
}

export const CarouselModal = ({
  slides,
  cta,
  autoplay,
  onClose,
  isOpened = true,
  ...props
}: CarouselModalProps) => {
  return createPortal(
    <ModalCarousel
      theme={"dark"}
      type={"full"}
      appear={"fade"}
      onClose={onClose}
      isOpened={isOpened}
      {...props}
    >
      <ModalSwiper
        modules={[Pagination, Navigation, Autoplay]}
        spaceBetween={0}
        navigation={{
          nextEl: ".swiper-navigation-next",
          prevEl: ".swiper-navigation-prev",
        }}
        keyboard={{ onlyInViewport: true, enabled: true }}
        autoplay={autoplay}
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={"slide-" + i}>
            {({ isActive }) => (
              <figure>
                {slide.image && (
                  <Image
                    src={getImage(slide.image)}
                    alt={getImageProp('alt', slide.image) || slide.title || "Image"}
                    title={slide.title}
                    fill
                    style={{ objectFit: "contain" }}
                    sizes={FULL_WIDTH}
                  />
                )}
                {slide.video && (
                  <Video
                    video={
                      typeof slide.video == "string"
                        ? { src: slide.video, title: slide.title }
                        : slide.video
                    }
                    playing={isActive ? undefined : false}
                    style={{ objectFit: "contain" }}
                    controls
                  />
                )}

                {/* {slide.caption && slide.title &&
                  <Link href={slide.link?.href} { ...slide.link } display={'block'}>
                    <Overlay>
                      {slide.caption && <ImageCaption>{slide.caption}</ImageCaption>}
                      {slide.title && <ImageTitle>{slide.title}</ImageTitle>}
                    </Overlay>
                  </Link>
                }*/}
              </figure>
            )}
          </SwiperSlide>
        ))}
      </ModalSwiper>
      <PreviousButton className="swiper-navigation-prev" theme={"light"} />
      <NextButton className="swiper-navigation-next" theme={"light"} />
    </ModalCarousel>,
    document.body,
  );
};
